(function($) {
  
  $(document).ready(function() {
    
  });
  
})(jQuery);

function initHomeCardsScroll(){
  var $ = jQuery;
  $(window).on('resize',function(){
    $('.m-home-cards-scroll').each(function(){
        var minh = 0;
        $(this).find('.m-card-event,.m-card-horizontal,.m-post-text-listing,.m-card-blog,.m-card-vertical').each(function(){
            if($(this).outerHeight()>minh){
                minh = $(this).outerHeight();
            }
        })
        $(this).find('.m-card-event,.m-card-horizontal,.m-post-text-listing,.m-card-blog,.m-card-vertical').css('min-height',minh)
    })
  }).trigger('resize');

  /*$('.m-home-cards-scroll').mousewheel(function(e){
    $(this).scrollLeft($(this).scrollLeft()-e.deltaY*e.deltaFactor);
    e.preventDefault();
  })*/
}